import Image from "next/image";
import { cn } from "@/lib/utils";

type CostDocLogoProps = {
  className?: string;
  imageClassName?: string;
  theme?: "light" | "dark";
  showText?: boolean;
  priority?: boolean;
};

export function CostDocLogo({
  className,
  imageClassName,
  theme = "light",
  showText = true,
  priority = false,
}: CostDocLogoProps) {
  const isDark = theme === "dark";

  if (!showText) {
    return (
      <div className={cn("inline-flex items-center", className)}>
        <Image
          src="/favicon.png"
          alt="CostDoc"
          width={40}
          height={40}
          className="h-12 w-12 object-contain"
          sizes="48px"
          loading="lazy"
          decoding="async"
        />
      </div>
    );
  }

  return (
    <div className={cn("inline-flex items-center shrink-0", className)}>
      <Image
        src={isDark ? "/logo-white.png" : "/logo.png"}
        alt="CostDoc"
        width={2442}
        height={480}
        className={cn("h-8 w-auto object-contain", imageClassName)}
        sizes="(max-width: 640px) 150px, 190px"
        priority={priority}
        loading={priority ? undefined : "lazy"}
        decoding="async"
      />
    </div>
  );
}
